<template>
  <div>
  <div class="container">
        <div class="row">
            
            <div class="col-lg-12 col-md-12 col-sm-24">
                <div class="row">&nbsp;</div>

                <div class="row hidesmall">&nbsp;&nbsp;<h5>Jouw behandelingen</h5></div>
                <div class="row hidesmall titleMenuBasket">&nbsp;&nbsp;</div>
                <div class="row hidesmall ">&nbsp;</div>

              <div class="col-lg-23 col-md-23">
                <template v-for="product in cart">
                  <cart-item :product="product" :hidedetails="true"></cart-item>
                </template>
              </div>

              <div class="row">&nbsp;</div>
              <div class="row hidesmall">&nbsp;&nbsp;<h5>Datum reservatie</h5></div>
              <div class="row hidesmall titleMenuBasket">&nbsp;&nbsp;</div>
              
              <div style = "text-align:center;">
                <div class="row hidesmall">&nbsp;</div>
                <div style="width:90%"><h5 style="font-weight: bold;">{{ getSelectedDateInfo }}</h5></div>
                <div style="width:90%">om</div>
                <div style="width:90%"><h2 style="font-weight: bold;" >{{ getSelectedTimeInfo }}</h2></div>
                <div class="row hidesmall">&nbsp;</div>
              </div>
              <div class="row hidesmall">&nbsp;</div>

              <div style = "text-align:center;background-color:#dedede;padding-top:10px;border-radius:10px;padding-bottom:5px;margin-bottom:10px;" v-if="this.selectedSinleStore != undefined">
                <div style="width:90%">Je afspraak gaat door in salon</div>
                <div style="width:90%"><h3 style="font-weight: bold;font-size:17px">{{this.selectedSinleStore.UserName}}</h3></div>
                <div style="width:90%"></div>
                <div style="width:90%"><h5 style="font-weight: 500" >{{getSalonAdres (this.selectedSinleStore.Location)}}</h5></div>
                <div class="row hidesmall">&nbsp;</div>
              </div>
              <div class="row hidesmall">&nbsp;</div>

              <div class="product-btn"  style="color:#111111">
                  <a @click="navigateBack();"><i class="ion-arrow-left-c"  style="color:#111111"></i>Terug</a>
                </div>

            </div>
             <div class="col-lg-12 col-md-12 col-sm-24">
                <div class="row">&nbsp;</div>
                <div class="row">&nbsp;&nbsp;<h5 style="font-weight: bold;">Reservatie</h5>
                Vul je gegevens hieronder in en klik dan op de knop "Afspraak bevestigen!"
                </div>
                <div class="row hidesmall titleMenuBasket">&nbsp;&nbsp;</div>
                
                <div class="contact-message pt-20 pt-sm-20">
                  <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="first_name" placeholder="Voornaam *" type="text" v-model="firstname">    
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="last_name" placeholder="Achternaam *" type="text" v-model="lastname">   
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="email_address" placeholder="Email *" type="text" v-model="mail">    
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="phone" placeholder="Telefoon *" type="text" v-model="phone">   
                      </div>
                      <div class="col-lg-24 col-md-24 col-sm-24 col-xs-24">
                          <input name="cust_address" placeholder="Adresgegevens *" type="text" v-model="custaddress">    
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="cust_zipcode" placeholder="Postcode *" type="text" v-model="custzipcode">    
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-24">
                          <input name="cust_city" placeholder="Stad *" type="text" v-model="custcity">   
                      </div>
                      <div class="col-24">
                          <div class="contact2-textarea text-center">
                              <textarea placeholder="Opmerking" name="message"  class="form-control2" required="" style="height:80px" v-model="message"></textarea>     
                          </div>   
                          
                      </div>
                      <div class="col-lg-23 col-sm-24 col-xs-24" v-if="prcTotal > 0">
                          <div class="row"  v-if="prcTotal > 0" style="background-color:#999999;height:30px;line-height: 30px;border-radius:5px;padding-left:5px">
                              <div class="col-18"><strong style="color:#ffffff">Totaal voorschot gevraagd van </strong></div>
                              <div class="col-6" style="color:#ffffff;text-align:right">&euro;{{getTotalsAdvancePrice ()}}&nbsp;&nbsp;</div>
                          </div>
                          <hr>
                      </div>
                      <div class="col-24 contact-btn text-center"> 
                             <div class="product-btn" >
                                <a  @click="saveAppointment" v-bind:style="{ 'background-color': getColorApp, color: '#fff'}"><i class="ion-bag" ></i>{{kindMsgContinue}}</a>
                              </div>
                      </div>  
                      <div class="col-24" style="height:40px;">
                            
                      </div> 
                      <div class="row"><div class="col-24">&nbsp;</div></div>
                      <div class="row"><div class="col-24">&nbsp;</div></div>
                  </div>
                </div>
            </div>
           
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CartItem  from '../components/cart/CartItem';
  import CartCheckout from '../components/cart/CartCheckout.vue'
  import myHttpApi from "../api/myhttpapi"
  import {
    SPINNER_SHOW,
    SPINNER_HIDE,
    CLEAR_CART
  } from '../store/mutation-types'

  export default {
    metaInfo: {
        title: 'Afspraak bevestigen'
    },
    name: 'product-list',
    props: ['products'],
    data () {
      return {
        cart: this.$store.state.cart,
        flgShowDet : false,
        firstname : '',
        lastname  : '',
        mail : '',
        phone : '',
        message : '',
        custaddress : '',
        custcity : '',
        custzipcode : '',
        kindMsgContinue : '',
        token : '',
        prcTotal : 0,
        selectedSinleStore : undefined
      }
    },
    components: {
        cartItem : CartItem
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       },
      getSelectedTime () {
          return Vue.$selectedTime;
      },
      getSelectedTimeInfo () {
          return Vue.$selectedTime.TimeInfo;
      },
      getSelectedDateInfo () {
          return Vue.$selectedTime.DateInfo;
      }
    },
    mounted () {
        this.firstname = "";
        this.lastname = "";
        this.mail = "";
        this.phone = "";
        this.message = "";
        this.custaddress = "";
        this.custcity = "";
        this.custzipcode = "";
        this.token = "";
        this.kindMsgContinue = "Afspraak bevestigen";

        this.selectedSinleStore = Vue.$selectedStore;
       
        if (localStorage.firstname) {
          this.firstname = localStorage.firstname;
        }
        if (localStorage.lastname) {
          this.lastname = localStorage.lastname;
        }
        if (localStorage.phone) {
          this.phone = localStorage.phone;
        }
        if (localStorage.mail) {
          this.mail = localStorage.mail;
        }
        if (localStorage.message) {
          this.message = localStorage.message;
        }
        if (localStorage.custaddress) {
          this.custaddress = localStorage.custaddress;
        }
        if (localStorage.custcity) {
          this.custcity = localStorage.custcity;
        }
        if (localStorage.custzipcode) {
          this.custzipcode = localStorage.custzipcode;
        }

        this.prcTotal = this.getTotalsAdvance ();
        this.fullCustomerFromStore ();
    },
    methods: {
      isTrimSalon () {
        if (Vue.$storeSettings.KindStore === undefined) return false;
        if (Vue.$storeSettings.KindStore === 15) return true;
        return false;
      },
      isHasAnimalsEntered () {
        for (var c=0; c < this.cart.length; c++) {
           if (this.cart[c].Extra === undefined) return false;
           if (this.cart[c].Extra.length <= 1) return false;
        }
        return true;
      },
      getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      },
      navigate (item) {
        this.$router.push(item);
      },
      getTotalsAdvance () {
        var tot = 0
        console.log ("L1")
        for (var c=0; c < this.cart.length; c++) {
           tot += this.cart[c].PriceAdvance
        }
        console.log ("L2")

        this.kindMsgContinue = "Afspraak bevestigen";
        if (tot != 0)  this.kindMsgContinue = "Betaal en bevestig";

        return tot;
      },
      getTotalsAdvancePrice () {
        var t = this.prcTotal
        return t.toFixed (2)
      },
      fullCustomerFromStore () {
        
        if (Vue.$storeCustomer == undefined) {return;}

        this.firstname = Vue.$storeCustomer.FirstName;
        this.mail = Vue.$storeCustomer.Email;
        this.phone = Vue.$storeCustomer.Phone;
        this.lastname = Vue.$storeCustomer.LastName;
        this.custaddress = Vue.$storeCustomer.Address;
        this.custzipcode = Vue.$storeCustomer.ZipCode;
        this.custcity = Vue.$storeCustomer.City;
        this.token = Vue.$storeCustomer.Token;
        this.message = "";
      },
      navigateBack () {
        this.navigate ("/dateappoint");
      },
      showDetails () {
         this.flgShowDet = !this.flgShowDet;
      },
      startPayment (keyPayment) {
        
        this.$store.commit(SPINNER_SHOW);

        const token = {Search : keyPayment}

        myHttpApi.post( 'Basket/StartPayment', token)
              .then(response => {
                 var result = response.data;
                 
                 this.$store.commit(SPINNER_HIDE);
                 
                 if (result.ResultCode == 200)
                 {
                    document.location = result.ErrorMsg;
                 }
              }
          )
      },
      saveAppointment () {

          if (this.isTrimSalon ()) {
            if (!this.isHasAnimalsEntered()) {
               alert ("Dier naam ontbreekt");
               return;
            }
          }

          this.$store.commit(SPINNER_SHOW);
          localStorage.firstname = this.firstname;
          localStorage.lastname = this.lastname;
          localStorage.phone = this.phone;
          localStorage.mail = this.mail;
          localStorage.message = this.message;
          localStorage.custaddress = this.custaddress;
          localStorage.custzipcode = this.custzipcode;
          localStorage.custcity = this.custcity;

          const cust = {FirstName : this.firstname, LastName : this.lastname, Email: this.mail, Phone: this.phone, ExtraMessage : this.message,
                        Address: this.custaddress, ZipCode: this.custzipcode, City: this.custcity }
          const appointRec = {DatReservation: Vue.$selectedTime.Date ,  BasketItems: this.cart, Customer: cust, Token : this.token }
          myHttpApi.post( 'Basket/SaveReservation', appointRec)
              .then(response => {
                 var result = response.data;
                 this.$store.commit(SPINNER_HIDE);
                 if (result.ResultCode == 0)
                 {
                    
                   // this.$store.state.cart = [];
                    this.$store.commit(CLEAR_CART);
                    this.navigate ("/confirmed");
                 }
                 else if (result.ResultCode == 2)
                 {
                    alert (result.ErrorMsg);
                    //this.$router.go (-1);
                    this.navigate ("/DateAppoint");
                 }
                 else if (result.ResultCode == 15)
                 {
                      this.startPayment (result.ErrorMsg);
                 }
                 else
                 {
                     alert (result.ErrorMsg);
                 }
                 
              })
              .catch(error => {
                console.log(error);
                this.freePaces = [];
                alert (error);
                this.$store.commit(SPINNER_HIDE);
          });
      }
    }
  }
</script>
<style>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
  }
</style>



// WEBPACK FOOTER //
// src/pages/CartConfirm.vue